import "./Experience.scss";

const Experience = () => {
	return <h1 className="experience-header">03. Where I've Worked</h1>;
};

export default Experience;
